import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaxationTypeEnum } from '@zaoblako/shared/modules/catalog/enums/taxation-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable names for {@link TaxationTypeEnum} enumeration values */
export const TaxationTypeEnumNameI18n: EnumI18nInterface<TaxationTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [TaxationTypeEnum.GENERAL]: 'ОСН',
    [TaxationTypeEnum.SINGLE_IMPUTED_INCOME]: 'ЕНВД',
    [TaxationTypeEnum.SINGLE_AGRICULTURAL]: 'ЕСХН',
    [TaxationTypeEnum.PATENT]: 'ПНС',
    [TaxationTypeEnum.SIMPLIFIED_15]: 'УСН 15%',
    [TaxationTypeEnum.SIMPLIFIED_6]: 'УСН 6%',
  },
  [I18nLocalesEnum.EN_US]: {
    [TaxationTypeEnum.GENERAL]: 'GTS',
    [TaxationTypeEnum.SINGLE_IMPUTED_INCOME]: 'STII',
    [TaxationTypeEnum.SINGLE_AGRICULTURAL]: 'SAT',
    [TaxationTypeEnum.PATENT]: 'PTS',
    [TaxationTypeEnum.SIMPLIFIED_15]: 'STS 15%',
    [TaxationTypeEnum.SIMPLIFIED_6]: 'STS 6%',
  },
};
